import React from 'react';

export function CollapseIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="2" fill="none" viewBox="0 0 12 2">
      <path fill="#212121" d="M12 0.455H13.091V12.455H12z" transform="rotate(90 12 0.45459)" />
    </svg>
  );
}
